import React from "react";

import { useTranslation } from "react-i18next";

import { Button } from "@/src/components/ui/button";

import { RANKED_DEFAULT_LIMIT } from "./charts.utils";

import type { JSX } from "react";

interface ShowAllToggleProps {
  isExpanded: boolean;
  onToggle: () => void;
}

function ShowAllToggle({
  isExpanded,
  onToggle,
}: ShowAllToggleProps): JSX.Element {
  const { t } = useTranslation("editor-analytics");

  return (
    <Button aria-expanded={isExpanded} onClick={onToggle} variant="ghost">
      {isExpanded
        ? t("charts.showTop", { count: RANKED_DEFAULT_LIMIT })
        : t("charts.showAll")}
    </Button>
  );
}

export default ShowAllToggle;
